<template>
    <b-container class="container">
        <b-row>
            <b-col>
                <div class="head mb-4">
                    <h1>
                        <slot name="title" />
                    </h1>
                    <p>
                        <slot name="subtitle" />
                    </p>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="showFeedback">
            <b-col>
                <slot name="feedback" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form v-bind="$attrs" v-on="$listeners" @submit="$event.preventDefault()">
                    <slot name="fields" />

                    <div v-if="showOptions" class="mb-3 d-flex justify-content-between">
                        <slot name="keepMeSignedIn">
                            <CheckboxKeepMeLoggedIn
                                :checked="keepMeSignedIn"
                                @input="$emit('update:keepMeSignedIn', $event)"
                            />
                        </slot>

                        <slot name="forgotPassword">
                            <LinkForgotPassword />
                        </slot>
                    </div>

                    <slot name="button" />
                </b-form>
            </b-col>
        </b-row>
        <b-row v-if="showGoToLogin">
            <b-col>
                <slot name="goToLogin">
                    <p class="text-center my-3">
                        <LinkGoToLogin />
                    </p>
                </slot>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import LinkGoToLogin from './LinkGoToLogin'
import LinkForgotPassword from './LinkForgotPassword'
import CheckboxKeepMeLoggedIn from './CheckboxKeepMeLoggedIn'

export default {
    name: 'Form',
    inheritAttrs: false,
    components: {
        LinkGoToLogin,
        LinkForgotPassword,
        CheckboxKeepMeLoggedIn,
    },
    props: {
        keepMeSignedIn: {
            type: Boolean,
            required: false,
            default: false,
        },
        showFeedback: {
            type: Boolean,
            required: false,
            default: false,
        },
        showOptions: {
            type: Boolean,
            required: false,
            default: false,
        },
        showGoToLogin: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
.container {
    width: 400px;
}

.head {
    color: #6e6e6e;
    h1,
    p {
        text-align: center;
    }
    h1 {
        font-size: 1.7em;
    }
    p {
        font-size: 1.15em;
    }
}
</style>
